export default __webpack_public_path__ + "static/media/baseline-battery_90-24px.d23d59ac.svg";